import { useReducer, createContext, useEffect, useMemo } from "react";
import {
  putExpressSectionDataByKey,
  getExpressSectionDataByKey,
  ExpressStoreKey,
} from "@/pages/ExpressForm/express-data";
import { ExpressUiInfo, ExpressUiInfoInitialState } from "@/types/ui";

const ExpressUiInfoContext = createContext<{
  state: ExpressUiInfo;
  dispatch: React.Dispatch<any>;
}>({ state: ExpressUiInfoInitialState, dispatch: () => null });

const actionTypes = {
  SET_COLLECT_NOK_DETAILS: "SET_COLLECT_NOK_DETAILS",
  SET_COLLECT_EXECUTOR_DETAILS: "SET_COLLECT_EXECUTOR_DETAILS",
  SET: "SET",
  SET_STATE: "SET_STATE",
  SET_QUILTER: "SET_QUILTER",
  SET_QUILTER_ACCOUNT_INFO: "SET_QUILTER_ACCOUNT_INFO",
};

function reducer(state: ExpressUiInfo, action: { type: string; payload: any }): ExpressUiInfo {
  const { payload } = action;

  switch (action.type) {
    case actionTypes.SET:
      return { ...state, ...action.payload };

    case actionTypes.SET_QUILTER:
      return {
        ...state,
        quilter: { ...state.quilter, isQuilter: action.payload },
      };

    case actionTypes.SET_COLLECT_NOK_DETAILS:
      return {
        ...state,
        collectNokDetails: payload,
      };

    case actionTypes.SET_COLLECT_EXECUTOR_DETAILS:
      return {
        ...state,
        collectExecutorDetails: payload,
      };

    case actionTypes.SET_QUILTER_ACCOUNT_INFO:
      return {
        ...state,
        quilter: { ...state.quilter, ...action.payload },
      };

    case actionTypes.SET_STATE:
      return {
        ...state,
        willExists: payload.willExists,
        collectExecutorDetails: payload.collectExecutorDetails,
        collectNokDetails: payload.collectNokDetails,
        notifierRole: payload.notifierRole,
      };

    default:
      return ExpressUiInfoInitialState;
  }
}

const ExpressUiInfoProvider: React.FC = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, ExpressUiInfoInitialState);

  useEffect(() => {
    const source = getExpressSectionDataByKey(ExpressStoreKey.UiInfo);

    if (source) {
      dispatch({ type: actionTypes.SET, payload: source });
    }
  }, []);

  useEffect(() => {
    putExpressSectionDataByKey(ExpressStoreKey.UiInfo, state);
  }, [state.quilter, state.willExists, state.collectNokDetails, state.collectExecutorDetails]);

  const value = useMemo(() => ({ state, dispatch }), [state]);

  return <ExpressUiInfoContext.Provider value={value}>{children}</ExpressUiInfoContext.Provider>;
};
export { ExpressUiInfoContext, ExpressUiInfoProvider };
